
import React, { useEffect, useState } from "react";
import moment from 'moment';
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import styles from "../styles/style.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { PromoTypes } from "../../../interfaces";
import { getPromos,  } from "../api";
import { CONSTANTS } from "../../../lib/constants/messages";
import { ActionButton, DropDownMenu, Layout, Pagination, Popup } from "../../../ui";

const PromoCoupon = () => {
  const navigate = useNavigate();
  const { partnerName, partnerWebsiteId } = useParams();
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState<string>("");
  const [order, setSortOrder] = useState<number>(0);
  const [sortBy, setSortColumn] = useState<string>("");

  const [promos, setPromos] = useState<{ list: PromoTypes.Promos[]; count: number }>({
    list: [],
    count: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [dialog, setDialog] = useState({ show: false, id: "" });

  const listPromos = () => {
    const query: any = {
      page: (1 + pagination.skip),
      limit: pagination.limit,
      partnerWebsiteId:partnerWebsiteId,
      search,
      order,
      sortBy,
    };

    getPromos(query).then(({ data }) => {
      setPromos({
        list: data?.promos ?? [],
        count: data?.count ?? 0,
      });
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listPromos();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [pagination.skip,search]);
  

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );

    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };

    getPromos(query).then(({ data }) => {
      setPromos({ list: data.promos, count: data.count });
      setLoading(false);
    });
  };

  const renderSortIcon = (column: string) => {
    if (sortBy === column) {
      return order === LOCAL_CONSTANTS.descKey ? " ▼" : " ▲";
    }
    return null;
  };

  

  return (
  <>
      <div className={commonStyles.tableData}>
        <div className={commonStyles.topFilter}>
          <input
            type="search"
            placeholder="Search by title or promocode"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
           
          />
          {/* <button onClick={() => navigate(APP_ROUTES.NEW_PROMO)} className={styles.assCoupon} >+ Add new promo</button> */}
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {LOCAL_CONSTANTS.promosTableHeadersssss?.map((header: any) => (
                  <th
                    className={`${header?.value
                      ? "cursor-pointer"
                      : ""
                      }`}
                    onClick={() => {
                      if (header?.value) {
                        handleSort(header?.value);
                      }
                    }}
                    key={header?.value}
                  >
                    {header?.label}
                    {sortBy === header?.value &&
                      header?.value &&
                      renderSortIcon(header?.value)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={7} align="center">
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
             {!loading && (promos?.list?.length ?? 0) === 0 && (
                <tr>
                  <td colSpan={7} align="center">
                    {LOCAL_CONSTANTS.noPromoFound}
                  </td>
                </tr>
              )}
              {!loading &&
                promos?.list?.map((item) => (
                  <tr key={item._id}>
                    <td>{item.promoCode}</td>
                    <td>{item.title}</td>
                    <td>{item.type === 1 ? "Fixed" : "Percentage"}</td>
                    <td>{item.discountCurrency} {item.discount}</td>
                    <td>{moment(item?.startDate).format(LOCAL_CONSTANTS.dateFormat)}</td>
                    <td>{moment(item?.endDate).format(LOCAL_CONSTANTS.dateFormat)}</td>
                    {/* <td>
                      <Dropdown>
                        <div className="cursor-pointer">
                          <Dropdown.Toggle as={ActionButton}></Dropdown.Toggle>
                        </div>
                        <Dropdown.Menu as={DropDownMenu}>
                          <Dropdown.Item onClick={() => navigate(`${APP_ROUTES.PROMOS}/${item._id}`)}>
                            <FontAwesomeIcon
                              size="xs"
                              className="me-2"
                              icon={faPencilAlt}
                            />
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setDialog({ show: true, id: item._id })}>
                            <FontAwesomeIcon
                              size="xs"
                              className="me-2"
                              icon={faTrashAlt}
                            />
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        paginationState={pagination}
        setPaginationState={setPagination}
        count={promos.count}
      />
      {/* <Popup
        show={dialog.show}
        handleClose={() => setDialog({ show: false, id: "" })}
        heading={LOCAL_CONSTANTS.areYouSure}
        content={LOCAL_CONSTANTS.removePromo}
        handleSubmit={deletePromo}
        id={dialog.id}
      /> */}

</>
  );
};

export default PromoCoupon;
